export const FEATURE_NAME = '@zerops/zerops/feature/l7-config-dialog';